export const TENANT_MODULES = ['STORE', 'B2B_ORDERS', 'PRODUCTION', 'SECOND_HAND'] as const;

export type TenantModule = typeof TENANT_MODULES[number];

export const MODULE_ROUTES: Record<TenantModule, string[]> = {
  B2B_ORDERS: ['/orders'],
  PRODUCTION: ['/production', '/production-orders', '/providers', '/stock', '/inventory'],
  SECOND_HAND: ['/commission/drops', '/commission/settings'],
  STORE: ['/calendar', '/bookings', '/sales', '/customers'],
};

export const isModuleEnabled = (enabledModules: TenantModule[] | string[] | null | undefined, module: TenantModule) => {
  return !enabledModules || enabledModules.length === 0 || (enabledModules as string[]).includes(module);
};

export const getPersistedEnabledModules = (enabledModules: TenantModule[]) => {
  return enabledModules.length === TENANT_MODULES.length ? [] : enabledModules;
};
